export var powerReviewConfig = {
  apiKey: "5b0418c2-a80e-45d8-8596-50518e639de2",
  merchantGroupId: "0",
  merchantId: "628846",
  // pageId: id,
  // config: { style_sheet: powerReviewStyles },
  // components: {
  //     ReviewDisplay: `myCustomDisplayId`,
  //  },
  // this is for feedless, reference power-reviews docs
  product: {},
  init: function init() {// if you want to edit anything do it here, everything will be loaded before this function is called
  }
}; // read merchantId = 628846,  apiKey = 5b0418c2-a80e-45d8-8596-50518e639de2
// write merchantId = 628846,  apiKey = 053e70aa-9b2f-4f5a-83c3-35f419b22217
// pageId = product skus